// ABOUTME: Permission checking utilities for family member management
// ABOUTME: Handles primary caregiver and billing owner restrictions

interface FamilyMember {
  userId: number;
  isPrimaryCaregiver: boolean;
  isBillingOwner?: boolean;
}

export const canRemovePrimaryCaregiver = (
  userId: number,
  familyMembers: FamilyMember[]
): boolean => {
  const primaryCaregivers = familyMembers.filter(member => member.isPrimaryCaregiver);
  if (primaryCaregivers.length <= 1) {
    return false; // Cannot remove the last Primary Caregiver
  }
  return true;
};

export const shouldShowPrimaryCaregiverWarning = (
  userId: number,
  familyMembers: FamilyMember[]
): boolean => {
  const member = familyMembers.find(m => m.userId === userId);
  if (!member?.isPrimaryCaregiver) {
    return false;
  }
  const primaryCaregivers = familyMembers.filter(member => member.isPrimaryCaregiver);
  return primaryCaregivers.length <= 1;
};

export const getRemovalRestrictionReason = (
  userId: number,
  familyMembers: FamilyMember[]
): string | null => {
  const member = familyMembers.find(m => m.userId === userId);
  if (!member) return null;

  if (member.isBillingOwner) {
    return "This member is the billing owner of an active subscription and cannot be removed";
  }

  if (member.isPrimaryCaregiver) {
    const primaryCaregivers = familyMembers.filter(m => m.isPrimaryCaregiver);
    if (primaryCaregivers.length <= 1) {
      return "Cannot remove the last Primary Caregiver (at least one is required)";
    }
  }

  return null;
};
